export default __webpack_public_path__ + "static/media/093-left-arrow-6.2e1dc9a4.png";